module.exports = __webpack_public_path__ + "img/invite.9adaa795.svg";